import { EquippableItem, Offset } from "../defines/types"
import { Cabinet } from "../popup/cabinet"
import { GizmoCabinet } from "../popup/gizmocabinet"
import {
  isFeetEquipment,
  isGizmo,
  isHeadEquipment,
  isTorsoEquipment,
  isWeapon,
} from "./equipment"

// Arsenal has only 1 column
// Equipment will always be added in column 0
export function buildArsenal(
  offsets: Offset,
  name: string,
  description: string
): Cabinet {
  const arsenal = new Cabinet(offsets, name, description, displayArsenal)

  return arsenal
}
export function displayArsenal(e: EquippableItem[]): EquippableItem[][] {
  const arsenal = new Array(1)
  arsenal[0] = []

  // 1 column
  e.forEach((item) => {
    if (isWeapon(item.type)) {
      arsenal[0].push(item)
    }
  })

  return arsenal
}

// Gizmos has only 1 column
// Equipment will always be added in column 0
export function buildGizmos(
  offsets: Offset,
  name: string,
  description: string
): GizmoCabinet {
  const gizmos = new GizmoCabinet(offsets, name, description, displayGizmos)

  return gizmos
}
export function displayGizmos(e: EquippableItem[]): EquippableItem[][] {
  const gizmos = new Array(1)
  gizmos[0] = []

  // 1 column
  e.forEach((item) => {
    if (isGizmo(item.type)) {
      gizmos[0].push(item)
    }
  })

  return gizmos
}

// Arsenal has 3 columns
// HEAD = 0, TORSO = 1, FEET = 2
export function buildWardrobe(
  offsets: Offset,
  name: string,
  description: string
): Cabinet {
  const wardrobe = new Cabinet(offsets, name, description, displayWardrobe)

  return wardrobe
}
export function displayWardrobe(e: EquippableItem[]): EquippableItem[][] {
  const wardrobe = new Array(3)
  for (let i = 0; i < wardrobe.length; ++i) {
    wardrobe[i] = []
  }
  // head = 0, torso = 1, feet = 2
  e.forEach((item) => {
    let column = -1
    if (isHeadEquipment(item.type)) {
      column = 0
    } else if (isTorsoEquipment(item.type)) {
      column = 1
    } else if (isFeetEquipment(item.type)) {
      column = 2
    }

    if (column >= 0) {
      wardrobe[column].push(item)
    }
  })

  return wardrobe
}
